// Loader.js
import React from 'react';
import { TailSpin } from 'react-loader-spinner';

const Loader = ({ classes = ' vh-100' }) => {
    return (
        <div className={` d-flex justify-content-center align-items-center ${classes} `}>
            <TailSpin
                height="40"
                width="40"
                color="#f7941d"
                ariaLabel="loading"
                wrapperStyle={{}}
                wrapperClass="loading-border"
            />
        </div>
    );
};

export default Loader;